/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';

import utils from '../../../lib/utils';
import PhoneInput from '../../FormComponents/PhoneInput';
import BookingSoftwares from '../../../assets/AuthBookingSoftwares';

import './index.scss';

const locationOptions = [
  {
    label: 'Location Account',
    value: 'LOCATION',
  },
  {
    label: 'Brand Account',
    value: 'BRAND',
  },
];

const businessTypeOptions = [
  { value: 'TRUELARK', label: 'TRUELARK' },
  { value: 'WEAVE', label: 'WEAVE' },
];

const debounce = (func, wait, immediate) => {
  let timeout;
  return (...rest) => {
    const context = this;
    const args = rest;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export default class AuthSignUp extends React.Component {
  constructor() {
    super();

    // Get email from URL and pre-populate state
    const email = utils.getURLParameterByName('email');

    this.state = {
      firstName: '',
      lastName: '',
      email: email || '',
      password: '',
      phone: '',
      business_name: '',
      business_website: '',
      business_type: '',
      weave_phone_number: '',
      weave_location_id: '',
      account_type: 'NOT_SELECTED',
      billing_id: '',
      bookingSW: '',
      pricing_plan: '',
      domain: utils.getURLParameterByName('domain'),
      selectedOption: '',
      hasError: false,
      isPasswordVisible: false,
      isEmailInvalid: false,
      isFirstNameBlank: false,
      isLastNameBlank: false,
      isPassowrdMinLengthFail: false,
      isDomainBlank: false,
      isPlanBlank: false,
      isLocationBlank: false,
      isNonAPIbusiness: false,
      isWeavePhoneNumberBlank: false,
      isWeavePhoneNumberInvalid: false,
      isWeaveLocationIdBlank: false,
      isWeaveLocationIdInvalid: false,
      apiErrorMessage: '',
    };

    this.onSignupFormSubmit = this.onSignupFormSubmit.bind(this);
    this.onFirstNameChange = this.onFirstNameChange.bind(this);
    this.onLastNameChange = this.onLastNameChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onShowPasswordClick = this.onShowPasswordClick.bind(this);
    this.onDomainChange = this.onDomainChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onLocationCountChange = this.onLocationCountChange.bind(this);
    this.onBusinessTypeChange = this.onBusinessTypeChange.bind(this);
    this.onPlanChange = this.onPlanChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.debounceStripeSearch = this.debounceStripeSearch.bind(this);
    this.onBookingSoftwareChange = this.onBookingSoftwareChange.bind(this);
    this.onStripeIdChange = this.onStripeIdChange.bind(this);

    this.debounceStripeSearch = debounce((req) => {
      console.log(req);
      this.props.getStripeUser(req);
    }, 500);
  }

  componentDidMount() {
    this.props.getDomains();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.isRegisterUserFail === true &&
      !this.props.auth.isRegisterUserFail
    ) {
      this.setState({
        hasError: true,
        apiErrorMessage: nextProps.auth.errorMessage,
      });
    }
  }

  debounceStripeSearch = debounce(req => { console.log(req); this.props.getStripeUser(req); }, 500);

    onStripeIdChange=(event)=>{
      this.setState(
        {
          billing_id: utils.sanitizeHTML(event.target.value),
        },
        this.debounceStripeSearch(event.target.value),
      );
    }

  // if(event.target.name === 'billing_id'){
  //   console.log('Props',this.props);
  //   this.props.getStripeUser();
  // }

  onFirstNameChange(event) {
    this.setState(
      {
        firstName: utils.sanitizeHTML(event.target.value),
      },
      this.resetValidation,
    );
  }

  onLastNameChange(event) {
    this.setState(
      {
        lastName: utils.sanitizeHTML(event.target.value),
      },
      this.resetValidation,
    );
  }

  onEmailChange(event) {
    this.setState(
      {
        email: utils.sanitizeHTML(event.target.value),
      },
      this.resetValidation,
    );
  }

  onPasswordChange(event) {
    this.setState(
      {
        password: event.target.value.replace(/script/g, ''),
      },
      this.resetValidation,
    );
  }

  onShowPasswordClick(event) {
    event.preventDefault();

    this.setState({
      isPasswordVisible: !this.state.isPasswordVisible,
    });
  }

  onDomainChange(item) {
    this.setState({
      domain: item.domainId,
    }, this.updatePricingPlans);
    // const authe = utils.getCookie('authe');
    // const authp = utils.getCookie('authp');
    // this.props.getPricingPlans(item.domainId, this.state.account_type, authe, authp);
  }

  onPlanChange(item) {
    this.setState({
      pricing_plan: item.id,
    });
  }

  onBookingSoftwareChange(item) {
    this.setState({
      bookingSW: item.value,
    });
  }

  onChangeValue(event) {
    this.setState({
      selectedOption: event.target.value,
    });
  }

  onBusinessTypeChange(item) {
    this.setState({
      business_type: item.value,
      ...(item.value === 'WEAVE' ? { domain: 'DENTAL', account_type: 'LOCATION' } : { domain: '', account_type: '' }),
    }, this.updatePricingPlans);
    // if (item.value === 'WEAVE') {
    //   const authe = utils.getCookie('authe');
    //   const authp = utils.getCookie('authp');
    //   this.props.getPricingPlans('DENTAL', 'LOCATION', authe, authp);
    // }
  }

  onLocationCountChange(item) {
    this.setState({
      account_type: item.value,
    }, this.updatePricingPlans);
  }

  onSignupFormSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      this.props.postUser({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        password: this.state.password,
        phone: this.state.phone,
        business_name: this.state.business_name,
        business_website: this.state.business_website,
        business_type: this.state.business_type,
        pricing_plan: this.state.pricing_plan,
        billing_id: this.state.billing_id,
        account_type: this.state.account_type,
        domain_id: this.state.domain,
        selectedOption: this.state.selectedOption,
        booking_software: this.state.bookingSW,
        ...(this.state.business_type === 'WEAVE' && {
          weave_phone_number: this.state.weave_phone_number,
          weave_location_id: this.state.weave_location_id,
        }),
      });
    }
  }

  handleInputChange(event) {
    console.log('event.target.name', event.target.name, event.target.value);
    this.setState(
      {
        [event.target.name]: utils.sanitizeHTML(event.target.value),
      },
      this.resetValidation,
    );
  }

  // handleToggleButton(event) {
  //   console.log('event.target.name', this.state.isNonAPIbusiness);
  //   this.setState({
  //     isNonAPIbusiness: !this.state.isNonAPIbusiness,
  //   });
  // }

  validate() {
    const isValid =
      this.state.firstName &&
      this.state.lastName &&
      this.state.email &&
      this.state.password &&
      utils.isValidEmail(this.state.email) &&
      this.state.password.length >= 8 &&
      this.state.phone &&
      utils.isValidPhone(this.state.phone) &&
      this.state.business_name &&
      this.state.business_type &&
      utils.isValidURL(this.state.business_website) &&
      this.state.pricing_plan &&
      this.state.domain &&
      (this.state.business_type === 'WEAVE'
        ? this.state.weave_phone_number &&
          utils.isValidPhone(this.state.weave_phone_number) &&
          this.state.weave_location_id
        : true) &&
      (this.state.business_type === 'TRUELARK'
        ? this.state.account_type
        : true);

    this.setState({
      isEmailInvalid: !utils.isValidEmail(this.state.email),
      isFirstNameBlank: !this.state.firstName.trim(),
      isLastNameBlank: !this.state.lastName.trim(),
      isPasswordBlank: !this.state.password,
      isEmailBlank: !this.state.email,
      isPassowrdMinLengthFail: this.state.password.length < 8,
      isPhoneBlank: !this.state.phone,
      isPhoneInvalid: !utils.isValidPhone(this.state.phone),
      isBusinessNameBlank: !this.state.business_name,
      isBusinessWebsiteInvalid: !utils.isValidURL(this.state.business_website),
      isBusinessTypeInvalid: !this.state.business_type,
      isLocationCountInvalid: !utils.isNumber(this.state.account_type),
      isDomainBlank: !this.state.domain,
      isLocationBlank: !this.state.account_type,
      isPlanBlank: !this.state.pricing_plan,
      isWeaveLocationIdBlank:
        this.state.business_type === 'WEAVE' && !this.state.weave_location_id,
      isWeaveLocationIdInvalid:
        this.state.business_type === 'WEAVE' && !this.state.weave_location_id,
      isWeavePhoneNumberBlank:
        this.state.business_type === 'WEAVE' && !this.state.weave_phone_number,
      isWeavePhoneNumberInvalid:
        this.state.business_type === 'WEAVE' &&
        !utils.isValidPhone(this.state.weave_phone_number),
    });

    return isValid;
  }

  resetValidation() {
    this.setState({
      isEmailInvalid: false,
      isFirstNameBlank: false,
      isLastNameBlank: false,
      isPasswordBlank: false,
      isEmailBlank: false,
      isPassowrdMinLengthFail: false,
      isDomainBlank: false,
      isPlanBlank: false,
      isLocationBlank: false,
    });
  }

  updatePricingPlans() {
    const authe = utils.getCookie('authe');
    const authp = utils.getCookie('authp');
    this.props.getPricingPlans(this.state.domain, this.state.account_type, authe, authp, this.state.business_type);
  }

  render() {
    let errorMessage = '';
    let showErrorMessage = false;
    const bookingSoftwaresList = Object.keys(BookingSoftwares)
      .map((key) => {
        return BookingSoftwares[key];
      })
      .filter((item) => {
        return item.type.indexOf(this.state.domain) !== -1;
      });
    console.log('bookingSoftwaresList', bookingSoftwaresList, locationOptions);
    if (this.state.hasError) {
      errorMessage = this.state.apiErrorMessage ||
        'An account already exists with this email ID. Please Sign In to continue';
      showErrorMessage = true;
    } else {
      let errorCount = 0;
      if (this.state.isFirstNameBlank) {
        errorMessage = 'First Name cannot be blank';
        errorCount += 1;
      }
      if (this.state.isLastNameBlank) {
        errorMessage = 'Last Name cannot be blank';
        errorCount += 1;
      }
      if (this.state.isEmailBlank) {
        errorMessage = 'Email cannot be blank';
        errorCount += 1;
      }
      if (this.state.isPasswordBlank) {
        errorMessage = 'Password cannot be blank';
        errorCount += 1;
      }
      if (this.state.isEmailInvalid) {
        errorMessage = 'Please enter a valid email id';
        errorCount += 1;
      }
      if (this.state.isPassowrdMinLengthFail) {
        errorMessage = 'Password should be at least 8 characters';
        errorCount += 1;
      }
      if (this.state.isDomainBlank) {
        errorMessage = 'Please select a domain';
        errorCount += 1;
      }
      if (this.state.isPlanBlank) {
        errorMessage = 'Please select a pricing plan';
        errorCount += 1;
      }
      if (this.state.isLocationBlank) {
        errorMessage = 'Please select location setup';
        errorCount += 1;
      }
      if (this.s) {
        if (errorCount > 1) {
          errorMessage = 'Please provide necessary details to move forward';
          showErrorMessage = true;
        }
      }
      if (errorCount == 1) {
        showErrorMessage = true;
      }
    }
    const { auth } = this.props;

    return (
      <div className="auth-signup">
        <div className="auth-signup__left">
          <h3>Setup your virtual assistant in less than 30min!</h3>
          <ul className="auth-signup__left__features">
            <li className="feature">
              <span className="feature__bullet">1</span>
              <p className="feature__title">Connect your booking software</p>
              <p className="feature__subtitle">
                Authorize TrueLark to access staff schedules and services
                information
              </p>
            </li>
            <li className="feature">
              <span className="feature__bullet">2</span>
              <p className="feature__title">Connect your booking phone</p>
              <p className="feature__subtitle">
                Forward your missed calls to a unique text-only number that we
                assign to your business
              </p>
            </li>
            <li className="feature">
              <span className="feature__bullet">3</span>
              <p className="feature__title">Get Started</p>
              <p className="feature__subtitle">
                No commitments or long-term contracts
              </p>
            </li>
          </ul>
        </div>
        <div className="auth-signup__right">
          <div className="auth-signup__container">
            <div className="auth-signup__container__form">
              {showErrorMessage ? (
                <div className="message message--error">{errorMessage}</div>
              ) : (
                undefined
              )}
              <form onSubmit={this.onSignupFormSubmit}>
                <div className="form-group form-group--row">
                  <div className="form-group--half">
                    <label htmlFor="firstName">FIRST NAME</label>
                    <input
                      type="text"
                      name="firstName"
                      value={this.state.firstName}
                      onChange={this.onFirstNameChange}
                      className={classnames({
                        'has-error': this.state.isFirstNameBlank,
                      })}
                    />
                  </div>
                  <div className="form-group--half">
                    <label htmlFor="lastName">LAST NAME</label>
                    <input
                      type="text"
                      name="lastName"
                      value={this.state.lastName}
                      onChange={this.onLastNameChange}
                      className={classnames({
                        'has-error': this.state.isLastNameBlank,
                      })}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="email">BUSINESS EMAIL</label>
                  <input
                    type="text"
                    name="email"
                    placeholder="you@example.com"
                    value={this.state.email}
                    onChange={this.onEmailChange}
                    className={classnames({
                      'has-error':
                        this.state.isEmailBlank || this.state.isEmailInvalid,
                    })}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">PASSWORD</label>
                  <div className="password-field">
                    <input
                      type={this.state.isPasswordVisible ? 'text' : 'password'}
                      name="password"
                      value={this.state.password}
                      onChange={this.onPasswordChange}
                      className={classnames({
                        'has-error':
                          this.state.isPasswordBlank ||
                          this.state.isPassowrdMinLengthFail,
                      })}
                    />
                    <a
                      href=""
                      onClick={this.onShowPasswordClick}
                      className="show-password"
                    >
                      {this.state.isPasswordVisible ? 'Hide' : 'Show'}
                    </a>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="phone">BUSINESS PHONE NUMBER</label>
                  <PhoneInput
                    placeholder=""
                    name="phone"
                    value={this.state.phone}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error':
                        this.state.isPhoneBlank || this.state.isPhoneInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="business_name">BUSINESS NAME</label>
                  <input
                    type="text"
                    name="business_name"
                    placeholder="Enter Business Name"
                    value={this.state.business_name}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'has-error':
                        this.state.isBusinessNameBlank ||
                        this.state.isBusinessNameInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="business_website">BUSINESS WEBSITE</label>
                  <input
                    type="text"
                    name="business_website"
                    placeholder="Enter Business Website"
                    value={this.state.business_website}
                    onChange={this.handleInputChange}
                    className={classnames({
                      'not-selected': this.state.isBusinessWebsiteInvalid,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="business_type">Business Type</label>
                  <Select
                    value={businessTypeOptions.filter(
                      (option) => option.value === this.state.business_type,
                    )}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    options={businessTypeOptions}
                    onChange={this.onBusinessTypeChange}
                    className={classnames({
                      'not-selected': this.state.isBusinessTypeInvalid,
                    })}
                  />
                </div>

                {this.state.business_type === 'WEAVE' && (
                  <div className="form-group">
                    <label htmlFor="weave_phone_number">
                      Weave AI Assistant Phone Number
                    </label>
                    <PhoneInput
                      placeholder=""
                      name="weave_phone_number"
                      value={this.state.weave_phone_number}
                      onChange={this.handleInputChange}
                      className={classnames({
                        'has-error':
                          this.state.isWeavePhoneNumberBlank ||
                          this.state.isWeavePhoneNumberInvalid,
                      })}
                    />
                  </div>
                )}

                {this.state.business_type === 'WEAVE' && (
                  <div className="form-group">
                    <label htmlFor="weave_location_id">LOCATION ID</label>
                    <input
                      type="text"
                      name="weave_location_id"
                      placeholder="Enter Weave Location ID"
                      value={this.state.weave_location_id}
                      onChange={this.handleInputChange}
                      className={classnames({
                        'has-error':
                          this.state.isWeaveLocationIdBlank ||
                          this.state.isWeaveLocationIdInvalid,
                      })}
                    />
                  </div>
                )}

                {this.state.business_type === 'TRUELARK' && (
                  <div className="form-group">
                    <label htmlFor="account_type">ACCOUNT TYPE</label>
                    <Select
                      value={locationOptions.filter(
                        (option) => option.value === this.state.account_type,
                      )}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      options={locationOptions}
                      onChange={this.onLocationCountChange}
                      className={classnames({
                        'not-selected': this.state.isLocationBlank,
                      })}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="billing_id">BILLING ID</label>
                  <input
                    type="text"
                    name="billing_id"
                    placeholder="Enter Billing Id"
                    value={this.state.billing_id}
                    onChange={this.onStripeIdChange}
                  />
                  {auth?.getStripeUser === false && (
                    <p className="stripe-user">
                      {auth?.stripe_user?.isValid ? (
                        <div className="stripe-user_valid">
                          {auth.stripe_user.Name}
                          <br />
                          {auth.stripe_user.business}
                        </div>
                      ) : this.state?.billing_id?.length > 0 ? (
                        <div className="stripe-user_invalid">
                          Invalid Billing Id
                        </div>
                      ) : (
                        ''
                      )}
                    </p>
                  )}
                </div>

                {this.state.business_type === 'TRUELARK' && (
                  <div className="form-group">
                    <label htmlFor="domain">MARKET</label>
                    <Select
                      value={this.props.domain.list.filter(
                        (option) => option.domainId === this.state.domain,
                      )}
                      getOptionLabel={(option) => option.domainName}
                      getOptionValue={(option) => option.domainId}
                      options={this.props.domain.list}
                      onChange={this.onDomainChange}
                      className={classnames({
                        'not-selected': this.state.isDomainBlank,
                      })}
                    />
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="pricing_plan">PLAN</label>
                  <Select
                    value={this.props.domain.plans.filter(
                      (option) => option.id === this.state.pricing_plan,
                    )}
                    getOptionLabel={(option) => option.value.name}
                    getOptionValue={(option) => option.id}
                    options={this.props.domain.plans}
                    onChange={this.onPlanChange}
                    className={classnames({
                      'not-selected': this.state.isPlanBlank,
                    })}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="booking_software">BOOKING SOFTWARE</label>
                  <Select
                    value={bookingSoftwaresList.filter(
                      (option) => option.value === this.state.bookingSW,
                    )}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    options={bookingSoftwaresList}
                    onChange={this.onBookingSoftwareChange}
                    className={classnames({
                      'not-selected': this.state.isPlanBlank,
                    })}
                  />
                </div>

                <div className="form-group">
                  <div className="auth-signup__container__form__login">
                    <p>
                      Already have a TrueLark account?&nbsp;
                      <NavLink to="/login">Login</NavLink>
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn--primary btn--lg"
                    disabled={this.props.auth.isRegistering}
                  >
                    CREATE ACCOUNT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AuthSignUp.defaultProps = {
  postUser: () => {},
  getDomains: () => {},
  auth: {
    isRegistering: false,
    isRegisterUserFail: false,
  },
  domain: {
    list: [],
    plans: [],
  },
};

AuthSignUp.propTypes = {
  postUser: PropTypes.func,
  getDomains: PropTypes.func,
  auth: PropTypes.shape({
    isRegistering: PropTypes.bool,
    isRegisterUserFail: PropTypes.bool,
  }),
  domain: PropTypes.shape({
    list: PropTypes.array,
    plans: PropTypes.array,
  }),
};
